<template>
  <div class="table-filter d-flex align-items-start">
    <div v-if="rangeErrorVisible" class="alerts">
      <div class="alert-wrapper fixed">
        <div class="alert alert-danger">
          <div class="alert__inner d-flex align-items-center justify-content-between">
            <span class="alert__text">{{ $t("maximum31dnu") }}</span>
            <div>
              <a class="ml-3 font-weight-bolder" @click="rangeErrorVisible = false">
                {{ $t("ok") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-control custom-control--date">
      <div class="custom-control__custom-input d-flex align-items-center justify-content-end">
        <DatePicker
          class="z-3"
          ref="picker"
          v-model="dateRange"
          teleport
          :locale="locale === 'cz' ? 'cs' : locale"
          :enable-time-picker="false"
          :range="{ partialRange: false }"
          :format="(date) => $t('datum')"
          :select-text="$t('zobrazit')"
          :cancel-text="$t('zpet')"
          :multi-calendars="2"
          @update:model-value="selectDate"
        >
          <template #input-icon />
        </DatePicker>

        <div class="atom-icon">
          <img src="@/assets/icons/ico-calendar.svg" />
        </div>
      </div>
      <div class="custom-control__selectedValues d-flex align-items-start justify-content-between">
        <div class="custom-control__selectedValues__value">
          <p>
            <span class="gray-text-light">{{ $t("od") }}</span>
            {{ $filters.date(dateRange[0]) }}
          </p>
          <p>
            <span class="gray-text-light">{{ $t("do") }}</span>
            {{ $filters.date(dateRange[1]) }}
          </p>
        </div>
        <img
          class="custom-control__selectedValues__icon pointer"
          src="@/assets/icons/actions/ico-delete-2.svg"
          @click="openDateRange()"
        />
      </div>
    </div>

    <button
      class="btn btn-primary d-flex align-items-center justify-content-center"
      @click="
        () => {
          filter()
          setSearch()
        }
      "
    >
      <div class="atom-icon">
        <img src="@/assets/icons/actions/ico-search-white.svg" />
      </div>
      {{ $t("hledat") }}
    </button>
    <button
      class="btn btn-primary d-flex ml-2 align-items-center justify-content-center"
      @click="
        () => {
          resetSearch()
          filter()
          setSearch()
        }
      "
    >
      <div class="atom-icon">
        <img src="@/assets/icons/actions/ico-refresh.svg" />
      </div>
      {{ $t("RESET_MESSAGE_FILTER") }}
    </button>
  </div>
</template>

<script>
import _ from "lodash"
import DatePicker from "@vuepic/vue-datepicker"
import "@vuepic/vue-datepicker/dist/main.css"

export default {
  components: { DatePicker },
  props: {
    rows: Array,
    from: String,
    to: String,
    all: Array,
    dateChanged: Boolean,
    count: Number,
    toApplyFilter: Boolean,
    orderBy: String,
    orderType: String
  },
  data() {
    return {
      dateFrom: "",
      dateTo: "",
      date: null,
      dateRange: [null, null],
      rangeErrorVisible: false
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
    uniqRows() {
      return _.uniq(this.rows, "message.EUI")
    },
    uniqAll() {
      return _.uniq(this.all, "message.EUI")
    }
  },
  watch: {
    selectedFilters: {
      deep: true,
      handler() {
        localStorage.deviceMessageFilter = JSON.stringify(this.selectedFilters)
      }
    },
    from() {
      this.dateRange[0] = this.from
    },
    to() {
      this.dateRange[1] = this.to
    },
    dateChanged() {
      if (this.dateChanged == true) {
        this.applyFilter()
      }
    },
    rows() {
      if (this.uniqRows.length == this.count && this.dateChanged == true) {
        this.applyFilter()
      }
    },
    toApplyFilter() {
      if (this.toApplyFilter == true) {
        this.applyFilter()
      }
    }
  },
  mounted() {
    if (this.from !== "" && this.to !== "") {
      this.dateRange = [this.from, this.to]
    }
    if (localStorage.simcardUsageFilter) {
      this.selectedFilters = JSON.parse(localStorage.simcardUsageFilter)
    }
    this.filter()
  },
  methods: {
    filter() {
      if (
        this.to != new Date(this.dateRange[1]).toISOString() ||
        this.from != new Date(this.dateRange[0]).toISOString()
      ) {
        this.setTo(new Date(this.dateRange[1]).toISOString())
        this.setFrom(new Date(this.dateRange[0]).toISOString())
      } else {
        this.applyFilter()
      }
    },
    applyFilter() {
      this.$emit("resetPaging")
      this.$emit("reloadItems")
    },
    filterState(state) {
      if (this.selectedFilters.states.indexOf(state) > -1) {
        this.selectedFilters.states.splice(this.selectedFilters.states.indexOf(state), 1)
      } else {
        this.selectedFilters.states.push(state)
      }
    },
    setTo(date) {
      this.$emit("setTo", date)
    },
    setFrom(date) {
      this.$emit("setFrom", date)
    },
    setSearch() {
      this.$emit("setSearch", this.search)
    },
    /**
     * reset filter settings to defaults
     */
    resetSearch() {
      // call reset function
      this.$emit("resetSearch")
    },
    selectDate() {
      //
      const parsedTo = Date.parse(this.dateRange[1])
      console.log(this.from, "FROOM")
      if (this.from == "1970-01-01T00:00:00.000Z") {
        const dateFrom1 = new Date(parsedTo - 31 * 24 * 60 * 60 * 1000)
        this.dateRange[0] = dateFrom1.toISOString()
      } else {
        this.rangeErrorVisible = false
      }
    },
    openDateRange() {
      this.$refs.picker.togglePicker()
    }
  }
}
</script>

<style lang="scss" scoped></style>
